import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, Button, HeadingText } from '@paypalcorp/pp-react';
import { recordIntent, ADD_DEV_RPS } from '../../../lib/appcenterIntent';
import { CHECKOUT } from '../../../lib/constants';
import {
  fireDetailsPageComponentFailureFpti,
  parseData,
  preventTabNabbing
} from '../../../lib/helpers';

const DetailsCTASection = ({
  componentContent,
  handleClickFPTI,
  fptiImpression,
  app
}) => {
  const { cta, title } = componentContent;
  const { context: { location: { domain } = {} } = {} } = app;
  const parsedCta = parseData(cta);

  const handleClick = (fptiLink, url) => {
    handleClickFPTI(fptiLink);
    if (
      componentContent.toolKey === CHECKOUT &&
      fptiLink === 'add_your_developer'
    ) {
      rpsRecordIntent();
    }
    window.open(url, '_blank', `${preventTabNabbing(url, domain)}`);
  };

  const rpsRecordIntent = () => {
    recordIntent({
      csrf: app.csrf,
      productArr: [ADD_DEV_RPS]
    });
  };

  if (!parsedCta?.length) {
    fireDetailsPageComponentFailureFpti({
      data: { cta },
      componentName: 'DetailsCTASection',
      fptiImpression
    });
    return null;
  }

  return (
    <section id="details-cta">
      <div className="detail-cta-title">
        <HeadingText level={2}  dangerouslySetInnerHTML={{ __html: title }}></HeadingText>
      </div>
      <div className="details-cta-container">
        {parsedCta.map((value, i) => (
          <div key={`details-cta-${i}`} className="details-cta-container-item">
            <h3>{value.title}</h3>
            <BodyText  className="font-size-p">{value.subtitle}</BodyText>
            <Button
              onClick={() => handleClick(value.fptiLinkName, value.url)}
              secondary
            >
              {value.text}
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};

DetailsCTASection.propTypes = {
  componentContent: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  app: PropTypes.object,
  fptiImpression: PropTypes.func.isRequied
};

export default DetailsCTASection;
